import { alphaNumericRegExWithSpace } from "../../common";
const isEmpty = require("../../common/functions/is-empty");

export function validateExcelRows(rowsData) {
  // Initialize an object to hold validation error messages
  let validationErrorsRows = {};

  // Iterate over each row of data
  rowsData.forEach((row, index) => {
    // Check if the row has fewer than 6 elements
    if (row.length < 6) {
      validationErrorsRows.excelFile =
        "Missing values in one or more rows, Fill the values and select the file again";
    }
    // Skip the first row (header row) and check if the first cell is not null
    if (index !== 0 && row[0] !== null) {
      // Validate the first cell against the regex
      if (alphaNumericRegExWithSpace.test(row[0]))
        validationErrorsRows.excelFile =
          "Item ERP Code should be a combination of A-Z, a-z, 0-9. Fix the value(s) and select the file again";
    }
    // Iterate over each cell in the row
    row.forEach((cell, index) => {
      // Skip the first cell and check if any subsequent cell is null
      if (index !== 0 && cell === null) {
        validationErrorsRows.excelFile =
          "Missing values in one or more rows, Fill the values and select the file again";
      }
    });
  });
  // Return an object containing validation errors and whether the rows are valid
  return {
    validationErrorsRows,
    // Check if there are no validation errors
    areRowsValid: isEmpty(validationErrorsRows),
  };
}
